import BrandLogo from '../Brand/BrandLogo'
import { brand } from '../../config/settings/brand'
import routes from '../../config/settings/routes'
import {
  Page,
  Card,
  BrandRow,
  BrandName,
  Code,
  Title,
  Description,
  Actions,
  PrimaryLink,
  SecondaryLink,
} from './NotFound.styles'

const NotFound = () => {
  return (
    <Page>
      <Card>
        <BrandRow>
          <BrandLogo size={36} />
          <BrandName>{brand.name}</BrandName>
        </BrandRow>

        <Code>Error 404</Code>
        <Title>No encontramos esta página</Title>
        <Description>
          Esa dirección no existe o ya no está disponible. Vuelve al inicio
          para seguir con tranquilidad.
        </Description>

        <Actions>
          <PrimaryLink to={routes.root}>Ir al inicio</PrimaryLink>
          <SecondaryLink to={routes.help}>Contactar soporte</SecondaryLink>
        </Actions>
      </Card>
    </Page>
  )
}

export default NotFound
